import { h, Component, Fragment, createRef } from "preact";
import TextInputBusiness from "./TextInputBusiness";
import {
  formatSize,
  sendRequest,
  validateBigFile,
  validateDeniedType,
  validateEmail,
  validateEmptyFile,
  validateFiles,
} from "../../tools";
import FileInputBusiness from "./FileInputBusiness";
import PropTypes from "prop-types";

export default class BusinessServiceRenewalForm extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    onSubmited: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.phoneInputRef = createRef();
    this.phoneAdditionalInputRef = createRef();
    this.fieldsName = {
      businessName: "Наименование юридического лица",
      address: "Юридический адрес",
      postAddress: "Почтовый адрес",
      countHours: "Число часов работы в сутки",
      countDay: "Число дней работы в месяц",
      phone: "Контактный телефон",
      email: "Электронная почта",
      fileZayvkaDogovor: "Заявка на заключения договора энергоснабжения",
      fileEgrn:
        "Свидетельство о государственной регистрации заявителя в качестве юридического лица или в качестве индивидуального предпринимателя",
      fileOgrn:
        "Свидетельство о постановке заявителя на учет в налоговом органе",
      filePassport: "Копия паспорта гражданина РФ",
      fileDoverennost:
        "Документы, подтверждающие полномочия лица, выступающего от имени исполнителя",
      fileUstav: "Устав",
      fileSOPS: "Свидетельство о праве собственности",
      fileDAKP: "Договор аренды(купли-продажи)",
      fileSOPPPZU:
        "Свидетельство о праве постоянного (бессрочного) пользования земельным участком",
      fileSOPPNVZU:
        "Свидетельство о праве пожизненного наследуемого владения земельным участком",
      fileDVPZU: "Договор временного пользования земельным участком",
      fileDPPHVOU:
        "Документы, подтверждающие право хозяйственного ведения (оперативного управления)",
      fileDPIZPVIP:
        "Документы, подтверждающие иные законные права владения и(или) пользования",
      fileAOTP: "Акт о технологическом присоединении",
      fileARBPE: "Акт разграничения балансовой принадлежности электросетей",
      fileLOPDUD:
        "Лицензия на осуществление предпринимательской деятельности по управлению многоквартирными домами - для управляющих организаций",
      fileDPNOPKU:
        "Документы, подтверждающие наличие у исполнителя обязанности предоставлять коммунальную услугу по электроснабжению потребителям, пользующимся помещениями в многоквартирном доме",
      fileIVRL:
        "Информация о включении в реестр лицензий субъекта Российской Федерации сведений об осуществлении управляющей организацией управления многоквартирным домом (многоквартирными домами)",
      filePVUDUK:
        "Протокол общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе в качестве способа управления многоквартирным домом управление управляющей организацией, и протокол общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе управляющей организации в лице той управляющей организации, которая обращается с заявкой, а также договор управления многоквартирным домом (если таковой заключен)",
      filePOKVUK:
        "Протокол открытого конкурса по выбору управляющей организации и(или) договор управления многоквартирным домом (если таковой заключен)",
      filePOSVUK:
        "Протокол общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе управляющей организации, и (или) договор управления многоквартирным домом, заключенный между товариществом или кооперативом и управляющей организацией",
      filePOSVSUK:
        "Протокол общего собрания собственников помещений в многоквартирном доме, в котором создано товарищество, или протокол общего собрания членов кооператива, в которых зафиксировано (отражено) решение о выборе в качестве способа управления многоквартирным домом управление соответственно товариществом или кооперативом",
      filePRVEMD: "Разрешение на ввод в эксплуатацию многоквартирного дома",
    };
    this.requiredFields = [
      "businessName",
      "address",
      "postAddress",
      "countHours",
      "countDay",
      "phone",
      "email",
      "fileZayvkaDogovor",
      "fileEgrn",
      "fileOgrn",
      "filePassport",
      // 'fileDoverennost',
      // 'fileUstav',
      // 'fileSOPS',
      // 'fileDAKP',
      // 'fileSOPPPZU',
      // 'fileSOPPNVZU',
      // 'fileDVPZU',
      // 'fileDPPHVOU',
      // 'fileDPIZPVIP',
      "fileAOTP",
      "fileARBPE",
      "fileLOPDUD",
      "fileDPNOPKU",
      "fileIVRL",
      // 'filePVUDUK',
      // 'filePOKVUK',
      // 'filePOSVUK',
      // 'filePOSVSUK',
      // 'filePRVEMD',
    ];
    this.fieldForAll = [
      "businessName",
      "address",
      "postAddress",
      "countHours",
      "countDay",
      "phone",
      "additionalPhone",
      "email",
      "fileZayvkaDogovor",
      "fileEgrn",
      "fileOgrn",
      "fileDoverennost",
      "fileSOPS",
      "fileDAKP",
      "fileSOPPPZU",
      "fileSOPPNVZU",
      "fileDVPZU",
      "fileDPPHVOU",
      "fileDPIZPVIP",
      "fileAOTP",
      "fileARBPE",
      "fileOSES",
    ];
    this.fieldFor = {
      legal_entity: [...this.fieldForAll, "fileUstav"],
      ip: [...this.fieldForAll, "filePassport"],
      iku_uk: [
        ...this.fieldForAll,
        "fileUstav",
        "fileLOPDUD",
        "fileDPNOPKU",
        "fileIVRL",
        "filePVUDUK",
        "filePOKVUK",
        "filePOSVUK",
        "fileDUMD",
      ],
      iku_tsg: [
        ...this.fieldForAll,
        "fileUstav",
        "fileLOPDUD",
        "fileDPNOPKU",
        "fileIVRL",
        "filePOSVSUK",
        "filePRVEMD",
      ],
    };
    this.files = {
      fileZayvkaDogovor: [],
      fileEgrn: [],
      fileOgrn: [],
      filePassport: [],
      fileDoverennost: [],
      fileUstav: [],
      fileSOPS: [],
      fileDAKP: [],
      fileSOPPPZU: [],
      fileSOPPNVZU: [],
      fileDVPZU: [],
      fileDPPHVOU: [],
      fileDPIZPVIP: [],
      fileAOTP: [],
      fileARBPE: [],
      fileOSES: [],
      fileLOPDUD: [],
      fileDPNOPKU: [],
      fileIVRL: [],
      filePVUDUK: [],
      filePOKVUK: [],
      filePOSVUK: [],
      fileDUMD: [],
      filePOSVSUK: [],
      filePRVEMD: [],
    };

    this.state = {
      currentTab: "legal_entity",
      currentIku: "uk",
      values: {
        ...this.files,
      },
      loading: false,
    };
    this.errorsApi = {};
    this.allowedFileTypes = [
      "jpg",
      "jpeg",
      "png",
      "pdf",
      "doc",
      "docx",
      "rtf",
      "xls",
      "xlsx",
      "zip",
    ];
    //5Mb 1024*1024*5
    this.maxSizeFile = 5242880;
    this.maxCountFile = 3;
  }

  clearForm = () => {
    this.submitted = false;
    this.errorsApi = {};
    $(this.phoneInputRef.current).val("");
    $(this.phoneAdditionalInputRef.current).val("");
    this.setState({
      values: {
        businessName: "",
        address: "",
        postAddress: "",
        countHours: "",
        countDay: "",
        phone: "",
        additionalPhone: "",
        email: "",
        ...this.files,
      },
    });
  };

  setPhoneMask(phoneRef, field) {
    const self = this;
    $(phoneRef)
      .mask("+7 (999) 999-99-99")
      .on("change", function (e) {
        self.setValues({ [field]: e.target.value });
      });
  }

  componentDidMount() {
    const self = this;
    this.setPhoneMask(this.phoneInputRef.current, "phone");
    this.setPhoneMask(this.phoneAdditionalInputRef.current, "additionalPhone");
    self.clearForm();
  }

  renderFileList = (file, key, field) => {
    let errorFile = [];
    if (validateBigFile(this.maxSizeFile)(file))
      errorFile.push(
        "Ограничение на размер файлов " + formatSize(this.maxSizeFile)
      );
    if (validateDeniedType(this.allowedFileTypes)(file))
      errorFile.push(
        "Допустимый формат файлов: " + this.allowedFileTypes.join(", ")
      );
    if (validateEmptyFile(file)) errorFile.push("Нельзя отправить пустой файл");
    if (key > this.maxCountFile - 1)
      errorFile.push("Нельзя отправить более " + this.maxCountFile + " файлов");

    return (
      <li
        className={`file-input__files-item ${
          errorFile.length ? "file-input__files-item_error" : ""
        }`}
        key={file.name + file.size}
      >
        <span className="file-input__files-item-name">{file.name}</span>
        <span className="file-input__files-item-size">
          {formatSize(file.size)}
        </span>
        <button
          className="file-input__files-item-delete"
          aria-label="Удалить файл"
          onClick={this.onDeleteFile(file, field)}
        ></button>
        {errorFile.map((errorItem) => (
          <p className="file-input__files-item-error-text">{errorItem}</p>
        ))}
      </li>
    );
  };

  render(props, state, context) {
    const errors = { ...this.errorsApi, ...this.validate() };
    const currentTab = state.currentTab;
    const currentIku = state.currentIku;
    const fileZayvkaDogovor = this.state.values.fileZayvkaDogovor.map(
      (file, key) => this.renderFileList(file, key, "fileZayvkaDogovor")
    );

    const fileEgrn = this.state.values.fileEgrn.map((file, key) =>
      this.renderFileList(file, key, "fileEgrn")
    );
    const fileOgrn = this.state.values.fileOgrn.map((file, key) =>
      this.renderFileList(file, key, "fileOgrn")
    );
    const filePassport = this.state.values.filePassport.map((file, key) =>
      this.renderFileList(file, key, "filePassport")
    );
    const fileDoverennost = this.state.values.fileDoverennost.map((file, key) =>
      this.renderFileList(file, key, "fileDoverennost")
    );
    const fileUstav = this.state.values.fileUstav.map((file, key) =>
      this.renderFileList(file, key, "fileUstav")
    );

    const fileSOPS = this.state.values.fileSOPS.map((file, key) =>
      this.renderFileList(file, key, "fileSOPS")
    );
    const fileDAKP = this.state.values.fileDAKP.map((file, key) =>
      this.renderFileList(file, key, "fileDAKP")
    );
    const fileSOPPPZU = this.state.values.fileSOPPPZU.map((file, key) =>
      this.renderFileList(file, key, "fileSOPPPZU")
    );
    const fileSOPPNVZU = this.state.values.fileSOPPNVZU.map((file, key) =>
      this.renderFileList(file, key, "fileSOPPNVZU")
    );
    const fileDVPZU = this.state.values.fileDVPZU.map((file, key) =>
      this.renderFileList(file, key, "fileDVPZU")
    );
    const fileDPPHVOU = this.state.values.fileDPPHVOU.map((file, key) =>
      this.renderFileList(file, key, "fileDPPHVOU")
    );
    const fileDPIZPVIP = this.state.values.fileDPIZPVIP.map((file, key) =>
      this.renderFileList(file, key, "fileDPIZPVIP")
    );

    const fileAOTP = this.state.values.fileAOTP.map((file, key) =>
      this.renderFileList(file, key, "fileAOTP")
    );
    const fileARBPE = this.state.values.fileARBPE.map((file, key) =>
      this.renderFileList(file, key, "fileARBPE")
    );

    const fileOSES = this.state.values.fileOSES.map((file, key) =>
      this.renderFileList(file, key, "fileOSES")
    );

    const fileLOPDUD = this.state.values.fileLOPDUD.map((file, key) =>
      this.renderFileList(file, key, "fileLOPDUD")
    );
    const fileDPNOPKU = this.state.values.fileDPNOPKU.map((file, key) =>
      this.renderFileList(file, key, "fileDPNOPKU")
    );
    const fileIVRL = this.state.values.fileIVRL.map((file, key) =>
      this.renderFileList(file, key, "fileIVRL")
    );

    const filePVUDUK = this.state.values.filePVUDUK.map((file, key) =>
      this.renderFileList(file, key, "filePVUDUK")
    );
    const filePOKVUK = this.state.values.filePOKVUK.map((file, key) =>
      this.renderFileList(file, key, "filePOKVUK")
    );
    const filePOSVUK = this.state.values.filePOSVUK.map((file, key) =>
      this.renderFileList(file, key, "filePOSVUK")
    );
    const fileDUMD = this.state.values.fileDUMD.map((file, key) =>
      this.renderFileList(file, key, "fileDUMD")
    );
    const filePOSVSUK = this.state.values.filePOSVSUK.map((file, key) =>
      this.renderFileList(file, key, "filePOSVSUK")
    );
    const filePRVEMD = this.state.values.filePRVEMD.map((file, key) =>
      this.renderFileList(file, key, "filePRVEMD")
    );

    return (
      <div className="tabs tabs_left">
        <ul className="tabs__title">
          <li className="tabs__item">
            <button
              className={`tabs__button ${
                currentTab === "legal_entity" ? "active" : ""
              }`}
              onClick={this.onChangeTab("legal_entity")}
            >
              Юр лицам
            </button>
          </li>
          <li className="tabs__item">
            <button
              className={`tabs__button ${currentTab === "ip" ? "active" : ""}`}
              onClick={this.onChangeTab("ip")}
            >
              ИП
            </button>
          </li>
          <li className="tabs__item">
            <button
              className={`tabs__button ${currentTab === "iku" ? "active" : ""}`}
              onClick={this.onChangeTab("iku")}
            >
              для ИКУ
            </button>
          </li>
        </ul>
        <form className="form">
          <div className="form__body">
            <fieldset className="form__fieldset form__fieldset_pt">
              <TextInputBusiness
                errors={errors.businessName}
                isRequired={this.isRequired("businessName")}
                name="Наименование юридического лица"
                inputProps={{
                  onChange: this.onChangeInput("businessName"),
                  value: state.values.businessName,
                  id: "businessName",
                }}
              />
              <TextInputBusiness
                errors={errors.address}
                isRequired={this.isRequired("address")}
                name="Юридический адрес"
                inputProps={{
                  onChange: this.onChangeInput("address"),
                  value: state.values.address,
                  id: "address",
                }}
              />
              <TextInputBusiness
                errors={errors.postAddress}
                isRequired={this.isRequired("postAddress")}
                name="Почтовый адрес"
                inputProps={{
                  onChange: this.onChangeInput("postAddress"),
                  value: state.values.postAddress,
                  id: "postAddress",
                }}
              />
            </fieldset>
            <fieldset className="form__fieldset">
              <div className="form__fieldset-title form__fieldset-title_accent">
                Режим работы объекта
              </div>
              <TextInputBusiness
                errors={errors.countHours}
                isRequired={this.isRequired("countHours")}
                name="Число часов работы в сутки"
                inputProps={{
                  type: "number",
                  min: 0,
                  max: 24,
                  onChange: this.onChangeInput("countHours"),
                  value: state.values.countHours,
                  id: "countHours",
                }}
              />
              <TextInputBusiness
                errors={errors.countDay}
                isRequired={this.isRequired("countDay")}
                name="Число дней работы в месяц"
                inputProps={{
                  type: "number",
                  min: 0,
                  max: 31,
                  onChange: this.onChangeInput("countDay"),
                  value: state.values.countDay,
                  id: "countDay",
                }}
              />
              <div className="form__item">
                <div
                  className={`form-field form-field_gray ${
                    errors.phone ? "form-field_state_error" : ""
                  }`}
                >
                  <label className="form-field__title" htmlFor="phone">
                    Контактный телефон
                  </label>
                  <input
                    className="input form-field__input"
                    type="text"
                    id="phone"
                    placeholder="+ 7 (000) 000 00 00"
                    ref={this.phoneInputRef}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="form__item">
                <div className="form-field form-field_gray">
                  <label
                    className="form-field__title"
                    htmlFor="additionalPhone"
                  >
                    Дополнительный номер телефона
                  </label>
                  <input
                    className="input form-field__input"
                    type="text"
                    id="additionalPhone"
                    placeholder="+ 7 (000) 000 00 00"
                    ref={this.phoneAdditionalInputRef}
                    autoComplete="off"
                  />
                </div>
              </div>
              <TextInputBusiness
                errors={errors.email}
                isRequired={this.isRequired("email")}
                name="Электронная почта"
                inputProps={{
                  onChange: this.onChangeInput("email"),
                  value: state.values.email,
                  id: "email",
                }}
              />
              <FileInputBusiness
                errors={errors.fileZayvkaDogovor}
                renderInput={true}
                title={
                  this.isRequired("fileZayvkaDogovor") +
                  "Заявка на заключения договора энергоснабжения"
                }
                onChangeFile={this.onChangeFile("fileZayvkaDogovor")}
                countFiles={state.values.fileZayvkaDogovor.length}
                fileList={fileZayvkaDogovor}
              />
            </fieldset>
            <fieldset className="form__fieldset">
              <div className="form__fieldset-title form__fieldset-title_accent">
                Правоустанавливающие документы ЮЛ
              </div>
              <FileInputBusiness
                errors={errors.fileEgrn}
                renderInput={true}
                title={
                  this.isRequired("fileEgrn") +
                  "Свидетельство о государственной регистрации заявителя в качестве юридического лица или в качестве индивидуального предпринимателя"
                }
                onChangeFile={this.onChangeFile("fileEgrn")}
                countFiles={state.values.fileEgrn.length}
                fileList={fileEgrn}
              />
              <FileInputBusiness
                errors={errors.fileOgrn}
                renderInput={true}
                title={
                  this.isRequired("fileOgrn") +
                  "Свидетельство о постановке заявителя на учет в налоговом органе"
                }
                onChangeFile={this.onChangeFile("fileOgrn")}
                countFiles={state.values.fileOgrn.length}
                fileList={fileOgrn}
              />
              <FileInputBusiness
                errors={errors.filePassport}
                renderInput={currentTab === "ip"}
                title={
                  this.isRequired("filePassport") +
                  "Копия паспорта гражданина РФ"
                }
                onChangeFile={this.onChangeFile("filePassport")}
                countFiles={state.values.filePassport.length}
                fileList={filePassport}
              />
              <FileInputBusiness
                errors={errors.fileDoverennost}
                renderInput={true}
                title={
                  this.isRequired("fileDoverennost") +
                  "Документы, подтверждающие полномочия лица, выступающего от имени исполнителя"
                }
                onChangeFile={this.onChangeFile("fileDoverennost")}
                countFiles={state.values.fileDoverennost.length}
                fileList={fileDoverennost}
              />
              <FileInputBusiness
                errors={errors.fileUstav}
                renderInput={
                  currentTab === "legal_entity" || currentTab === "iku"
                }
                title={this.isRequired("fileUstav") + "Устав"}
                onChangeFile={this.onChangeFile("fileUstav")}
                countFiles={state.values.fileUstav.length}
                fileList={fileUstav}
              />
            </fieldset>
            <fieldset className="form__fieldset">
              <div className="form__fieldset-title form__fieldset-title_accent">
                Документы, подтверждающие право владения
              </div>
              <FileInputBusiness
                errors={errors.fileSOPS}
                renderInput={true}
                title={
                  this.isRequired("fileSOPS") +
                  "Свидетельство о праве собственности"
                }
                onChangeFile={this.onChangeFile("fileSOPS")}
                countFiles={state.values.fileSOPS.length}
                fileList={fileSOPS}
              />
              <FileInputBusiness
                errors={errors.fileDAKP}
                renderInput={true}
                title={
                  this.isRequired("fileDAKP") + "Договор аренды(купли-продажи)"
                }
                onChangeFile={this.onChangeFile("fileDAKP")}
                countFiles={state.values.fileDAKP.length}
                fileList={fileDAKP}
              />
              <FileInputBusiness
                errors={errors.fileSOPPPZU}
                renderInput={true}
                title={
                  this.isRequired("fileSOPPPZU") +
                  "Свидетельство о праве постоянного (бессрочного) пользования земельным участком"
                }
                onChangeFile={this.onChangeFile("fileSOPPPZU")}
                countFiles={state.values.fileSOPPPZU.length}
                fileList={fileSOPPPZU}
              />
              <FileInputBusiness
                errors={errors.fileSOPPNVZU}
                renderInput={true}
                title={
                  this.isRequired("fileSOPPNVZU") +
                  "Свидетельство о праве пожизненного наследуемого владения земельным участком"
                }
                onChangeFile={this.onChangeFile("fileSOPPNVZU")}
                countFiles={state.values.fileSOPPNVZU.length}
                fileList={fileSOPPNVZU}
              />
              <FileInputBusiness
                errors={errors.fileDVPZU}
                renderInput={true}
                title={
                  this.isRequired("fileDVPZU") +
                  "Договор временного пользования земельным участком"
                }
                onChangeFile={this.onChangeFile("fileDVPZU")}
                countFiles={state.values.fileDVPZU.length}
                fileList={fileDVPZU}
              />
              <FileInputBusiness
                errors={errors.fileDPPHVOU}
                renderInput={true}
                title={
                  this.isRequired("fileDPPHVOU") +
                  "Документы, подтверждающие право хозяйственного ведения (оперативного управления)"
                }
                onChangeFile={this.onChangeFile("fileDPPHVOU")}
                countFiles={state.values.fileDPPHVOU.length}
                fileList={fileDPPHVOU}
              />
              <FileInputBusiness
                errors={errors.fileDPIZPVIP}
                renderInput={true}
                title={
                  this.isRequired("fileDPIZPVIP") +
                  "Документы, подтверждающие иные законные права владения и(или) пользования"
                }
                onChangeFile={this.onChangeFile("fileDPIZPVIP")}
                countFiles={state.values.fileDPIZPVIP.length}
                fileList={fileDPIZPVIP}
              />
            </fieldset>
            <fieldset className="form__fieldset">
              <div className="form__fieldset-title form__fieldset-title_accent">
                Документы о технологическом присоединении
              </div>
              <FileInputBusiness
                errors={errors.fileAOTP}
                renderInput={true}
                title={
                  this.isRequired("fileAOTP") +
                  "Акт о технологическом присоединении"
                }
                onChangeFile={this.onChangeFile("fileAOTP")}
                countFiles={state.values.fileAOTP.length}
                fileList={fileAOTP}
              />
              <FileInputBusiness
                errors={errors.fileARBPE}
                renderInput={true}
                title={
                  this.isRequired("fileARBPE") +
                  "Акт разграничения балансовой принадлежности электросетей"
                }
                onChangeFile={this.onChangeFile("fileARBPE")}
                countFiles={state.values.fileARBPE.length}
                fileList={fileARBPE}
              />
            </fieldset>
            <fieldset className="form__fieldset">
              <div className="form__fieldset-title form__fieldset-title_accent">
                Документы о допуске в эксплуатацию приборов учета
              </div>
              <FileInputBusiness
                errors={errors.fileOSES}
                renderInput={true}
                title={
                  this.isRequired("fileOSES") +
                  "Однолинейная схема электрической сети"
                }
                onChangeFile={this.onChangeFile("fileOSES")}
                countFiles={state.values.fileOSES.length}
                fileList={fileOSES}
              />
            </fieldset>
            {currentTab === "iku" && (
              <Fragment>
                <fieldset className="form__fieldset">
                  <div className="form__fieldset-title form__fieldset-title_accent">
                    Документы, подтверждающие наличие у исполнителя обязанности
                    предоставлять коммунальную услугу по электроснабжению
                    потребителям, пользующимся помещениями в многоквартирном
                    доме
                  </div>
                  <FileInputBusiness
                    errors={errors.fileLOPDUD}
                    renderInput={currentTab === "iku"}
                    title={
                      this.isRequired("fileLOPDUD") +
                      "Лицензия на осуществление предпринимательской деятельности по управлению многоквартирными домами - для управляющих организаций"
                    }
                    onChangeFile={this.onChangeFile("fileLOPDUD")}
                    countFiles={state.values.fileLOPDUD.length}
                    fileList={fileLOPDUD}
                  />
                  <FileInputBusiness
                    errors={errors.fileDPNOPKU}
                    renderInput={currentTab === "iku"}
                    title={
                      this.isRequired("fileDPNOPKU") +
                      "Документы, подтверждающие наличие у исполнителя обязанности предоставлять коммунальную услугу по электроснабжению потребителям, пользующимся помещениями в многоквартирном доме"
                    }
                    onChangeFile={this.onChangeFile("fileDPNOPKU")}
                    countFiles={state.values.fileDPNOPKU.length}
                    fileList={fileDPNOPKU}
                  />
                  <FileInputBusiness
                    errors={errors.fileIVRL}
                    renderInput={currentTab === "iku"}
                    title={
                      this.isRequired("fileIVRL") +
                      "Информация о включении в реестр лицензий субъекта Российской Федерации сведений об осуществлении управляющей организацией управления многоквартирным домом (многоквартирными домами)"
                    }
                    onChangeFile={this.onChangeFile("fileIVRL")}
                    countFiles={state.values.fileIVRL.length}
                    fileList={fileIVRL}
                  />
                </fieldset>
                <fieldset className="form__fieldset">
                  <div className="form__fieldset-title form__fieldset-title_accent">
                    Протоколы
                  </div>
                  <ul className="tabs__title">
                    <li className="tabs__item">
                      <button
                        className={`tabs__button ${
                          currentIku === "uk" ? "active" : ""
                        }`}
                        onClick={this.onChangeTabIku("uk")}
                      >
                        Протоколы для УК (ИКУ, МКД)
                      </button>
                    </li>
                    <li className="tabs__item">
                      <button
                        className={`tabs__button ${
                          currentIku === "tsg" ? "active" : ""
                        }`}
                        onClick={this.onChangeTabIku("tsg")}
                      >
                        Протоколы для ТСЖ (СНТ, кооперативов)
                      </button>
                    </li>
                  </ul>
                  <FileInputBusiness
                    errors={errors.filePVUDUK}
                    renderInput={currentTab === "iku" && currentIku === "uk"}
                    title={
                      this.isRequired("filePVUDUK") +
                      "Общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе в качестве способа управления многоквартирным домом управление управляющей организацией, и протокол общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе управляющей организации в лице той управляющей организации, которая обращается с заявкой, а также договор управления многоквартирным домом (если таковой заключен) "
                    }
                    onChangeFile={this.onChangeFile("filePVUDUK")}
                    countFiles={state.values.filePVUDUK.length}
                    fileList={filePVUDUK}
                  />
                  <FileInputBusiness
                    errors={errors.filePOKVUK}
                    renderInput={currentTab === "iku" && currentIku === "uk"}
                    title={
                      this.isRequired("filePOKVUK") +
                      "Открытого конкурса по выбору управляющей организации и(или) договор управления многоквартирным домом (если таковой заключен)"
                    }
                    onChangeFile={this.onChangeFile("filePOKVUK")}
                    countFiles={state.values.filePOKVUK.length}
                    fileList={filePOKVUK}
                  />
                  <FileInputBusiness
                    errors={errors.filePOSVUK}
                    renderInput={currentTab === "iku" && currentIku === "uk"}
                    title={
                      this.isRequired("filePOSVUK") +
                      "Общего собрания собственников помещений в многоквартирном доме, на котором принято решение о выборе управляющей организации, и (или) договор управления многоквартирным домом, заключенный между товариществом или кооперативом и управляющей организацией"
                    }
                    onChangeFile={this.onChangeFile("filePOSVUK")}
                    countFiles={state.values.filePOSVUK.length}
                    fileList={filePOSVUK}
                  />
                  <FileInputBusiness
                    errors={errors.fileDUMD}
                    renderInput={currentTab === "iku" && currentIku === "uk"}
                    title={
                      this.isRequired("fileDUMD") +
                      "Договор управления многоквартирным домом, заключенный между застройщиком и управляющей организацией"
                    }
                    onChangeFile={this.onChangeFile("fileDUMD")}
                    countFiles={state.values.fileDUMD.length}
                    fileList={fileDUMD}
                  />
                  <FileInputBusiness
                    errors={errors.filePOSVSUK}
                    renderInput={currentTab === "iku" && currentIku === "tsg"}
                    title={
                      this.isRequired("filePOSVSUK") +
                      "Общего собрания собственников помещений в многоквартирном доме, в котором создано товарищество, или протокол общего собрания членов кооператива, в которых зафиксировано (отражено) решение о выборе в качестве способа управления многоквартирным домом управление соответственно товариществом или кооперативом"
                    }
                    onChangeFile={this.onChangeFile("filePOSVSUK")}
                    countFiles={state.values.filePOSVSUK.length}
                    fileList={filePOSVSUK}
                  />
                  <FileInputBusiness
                    errors={errors.filePRVEMD}
                    renderInput={currentTab === "iku" && currentIku === "tsg"}
                    title={
                      this.isRequired("filePRVEMD") +
                      "Разрешение на ввод в эксплуатацию многоквартирного дома"
                    }
                    onChangeFile={this.onChangeFile("filePRVEMD")}
                    countFiles={state.values.filePRVEMD.length}
                    fileList={filePRVEMD}
                  />
                </fieldset>
              </Fragment>
            )}
            <fieldset className="form__fieldset">
              {!!errors &&
                Object.values(errors).map((item) => {
                  return (
                    <p className="form__error-text" title={item}>
                      {item}
                    </p>
                  );
                })}
              <div className="form__item">
                <button
                  className="button-primary button-primary_pdv_lg"
                  onClick={this.onSubmitForm}
                  disabled={Object.keys(errors).length}
                >
                  {this.state.loading ? "Отправка заявки" : "Отправить заявку"}
                </button>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
    );
  }

  onChangeTab = (currentTab) => (e) => {
    e.preventDefault();
    this.setState({ currentTab });
  };
  onChangeTabIku = (currentIku) => (e) => {
    e.preventDefault();
    this.setState({ currentIku });
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  validate = () => {
    let errors = {};
    const self = this;
    if (!this.submitted) return errors;
    const { values, currentTab, currentIku } = this.state;
    const tabName =
      currentTab !== "iku" ? currentTab : currentTab + "_" + currentIku;
    const fieldForTab = self.fieldFor[tabName];

    this.requiredFields.forEach((requiredField) => {
      if (
        values[requiredField].length === 0 &&
        fieldForTab.includes(requiredField)
      ) {
        const fieldName =
          requiredField in self.fieldsName
            ? self.fieldsName[requiredField]
            : "";
        errors[requiredField] = `Обязательно для заполнения: "${fieldName}"`;
      }
    });

    if (
      values.countHours.length &&
      (parseInt(values.countHours) > 24 || parseInt(values.countHours) < 0)
    ) {
      errors.countHours =
        "Число часов работы в сутки должно быть больше 0 и меньше 24";
    }

    if (
      values.countDay.length &&
      (parseInt(values.countDay) > 31 || parseInt(values.countDay) < 0)
    ) {
      errors.countDay =
        "Число дней работы в месяц должно быть больше 0 и меньше 31";
    }

    if (values.email && !validateEmail(values.email)) {
      errors.email = "Неверный e-mail";
    }

    Object.getOwnPropertyNames(this.files).forEach((fieldName) => {
      if (fieldForTab.includes(fieldName)) {
        errors = {
          ...errors,
          ...validateFiles(
            values[fieldName],
            self.maxCountFile,
            self.maxSizeFile,
            self.allowedFileTypes
          ),
        };
      }
    });

    return errors;
  };

  onChangeFile = (field) => (e) => {
    this.setValues({
      [field]: [...this.state.values[field], ...e.target.files],
    });
  };

  onDeleteFile = (file, field) => (e) => {
    e.preventDefault();
    this.setValues({
      [field]: [...this.state.values[field].filter((item) => item !== file)],
    });
  };

  onChangeInput = (field) => (e) => {
    this.setValues({ [field]: e.target.value });
  };

  setValues = (values) => {
    this.removeErrorsApi(values);
    this.setState((state, props) => ({
      values: {
        ...state.values,
        ...values,
      },
    }));
  };

  removeErrorsApi = (fields) => {
    const self = this;
    Object.keys(fields).map((field) => {
      if (field in self.errorsApi) {
        delete self.errorsApi[field];
      }
    });
  };

  onSubmitForm = (e) => {
    e.preventDefault();

    const self = this;
    this.submitted = true;
    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.forceUpdate();
      return;
    }

    this.setState({ loading: true });
    const formData = new FormData();
    const { values, currentTab, currentIku } = this.state;
    const tabName =
      currentTab !== "iku" ? currentTab : currentTab + "_" + currentIku;
    const fieldForTab = self.fieldFor[tabName];

    let type = "ЮЛ";

    switch (currentTab) {
      case "legal_entity":
        type = "Юридическое лицо";
        break;
      case "ip":
        type = "ИП";
        break;
      case "iku":
        if (currentIku === "uk") {
          type = "УК, ИКУ, МКД";
        } else {
          type = "ТСЖ, СНТ, кооператив";
        }
        break;
    }

    formData.append("type", type);

    fieldForTab.forEach((field) => {
      if (self.files[field]) {
        if (values[field].length) {
          values[field].forEach((item) => {
            formData.append(field + "[]", item);
          });
        }
      } else {
        formData.append(field, values[field]);
      }
    });

    sendRequest(this.props.url, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    }).then((data) => {
      self.setState({ loading: false });
      if (data.status === 200) {
        this.clearForm();
        if (typeof this.props.onSubmited === "function") {
          this.props.onSubmited();
        }
      }
      if (data.status === 422) {
        JSON.parse(data.data).map((item) => {
          self.errorsApi[item["field"]] = item.message;
        });
      }
    });
  };
}
